import { render } from "./admin-invoices.vue?vue&type=template&id=61c399ea"
import script from "./admin-invoices.vue?vue&type=script&lang=js"
export * from "./admin-invoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__